<template>
  <CHeader class="d-flex justify-content-between" fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <img loading=lazy src="../assets/logo.png">
    </CHeaderBrand>
    <select v-model="currentLanguage">
      <option value="pt">{{$t("portuguese")}}</option>
      <option value="en">{{$t("english")}}</option>
    </select>
  </CHeader>
</template>

<script>
export default {
  name: 'TheHeader',
  data()
  {
    return {
      currentLanguage: this.$i18n.locale
    }
  },
  watch:
  {
    currentLanguage: function(val)
    {
      this.$i18n.locale = val;
      localStorage.setItem('locale', val);
      this.$router.go(0);
    }
  }
}
</script>

<style scoped>
body > div > div.c-wrapper > header > a > img
{
  height: 48px;
  width: auto;
}

.c-header .c-header-toggler
{
  background-color: white;
  margin: 2px 0 !important;
}

select
{
  background: transparent;
  border: none;
  color: var(--secondary);
  padding-right: 0.5rem;
  margin-right: 1rem;
  cursor: pointer;
}

select > option
{
  color: black;
}
</style>